import template from './rw-user-class.html';

export default {
  template,
  controller: 'RwUserClassController',
  bindings: {
    userClass: '@'
  },
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-user-class/rw-user-class-component.js